var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "apply_kid_dialog album-studio-picker",
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.isAddStudentInAlbumDialog,
            "show-close": true,
            width: "70%",
            top: "100px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isAddStudentInAlbumDialog = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "title_dialog" }, [
                    _c("i", { staticClass: "el-icon-user-solid" }),
                    _c("span", [_vm._v("Danh sách học sinh")]),
                  ]),
                  _c("p", { staticClass: "album-dialog-description" }, [
                    _vm._v(
                      "Chọn lớp, trạng thái và tìm học sinh để xác nhận phạm vi hiển thị album."
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "Phase2ActionButton",
                        {
                          attrs: {
                            type: "default",
                            size: "small",
                            icon: "el-icon-circle-close",
                          },
                          on: { click: _vm.handleClose },
                        },
                        [_vm._v("\n          Hủy bỏ\n        ")]
                      ),
                      _c(
                        "Phase2ActionButton",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-circle-check",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleSaveForm()
                            },
                          },
                        },
                        [_vm._v("\n          Xác nhận\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "body_dialog" }, [
            _c(
              "div",
              { staticClass: "section_filter" },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", gutter: 12 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "popper-class": "album-studio-popper",
                              multiple: "",
                              filterable: "",
                              "allow-create": "",
                              "default-first-option": "",
                              placeholder: "Chọn lớp",
                              "aria-label": "Chọn lớp học",
                            },
                            on: { change: _vm.handleChangeFilter },
                            model: {
                              value: _vm.classesApply,
                              callback: function ($$v) {
                                _vm.classesApply = $$v
                              },
                              expression: "classesApply",
                            },
                          },
                          _vm._l(_vm.listClass, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.className, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "popper-class": "album-studio-popper",
                              placeholder: "Trạng thái học sinh",
                              "aria-label": "Trạng thái học sinh",
                            },
                            on: { change: _vm.handleChangeFilter },
                            model: {
                              value: _vm.statusKids,
                              callback: function ($$v) {
                                _vm.statusKids = $$v
                              },
                              expression: "statusKids",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "Tất cả trạng thái", value: "" },
                            }),
                            _vm._l(
                              [
                                "STUDYING",
                                "STUDY_WAIT",
                                "RESERVE",
                                "LEAVE_SCHOOL",
                                "OUT_SCHOOL",
                              ],
                              function (status) {
                                return _c("el-option", {
                                  key: status,
                                  attrs: {
                                    label: _vm.parseKidStatusVietnamese(status),
                                    value: status,
                                  },
                                })
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm.classesApply.length > 0
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: true,
                                placeholder: "Nhập tên học sinh",
                                "aria-label": "Tìm kiếm theo tên học sinh",
                              },
                              on: {
                                change: _vm.handleChangeFilter,
                                clear: _vm.handleChangeFilter,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-search",
                                            "aria-label": "Tìm kiếm",
                                          },
                                          on: { click: _vm.handleChangeFilter },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3930812149
                              ),
                              model: {
                                value: _vm.nameKids,
                                callback: function ($$v) {
                                  _vm.nameKids = $$v
                                },
                                expression: "nameKids",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                class:
                  _vm.kidsDataFilter.length === 0
                    ? "wrap_data no_data"
                    : "wrap_data",
              },
              [
                _vm.kidsDataFilter.length > 0
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "select-all-box" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { indeterminate: _vm.isIndeterminate },
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.checkAll,
                                callback: function ($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll",
                              },
                            },
                            [_vm._v("\n              Tất cả\n            ")]
                          ),
                          _c("span", { staticClass: "album-picker-count" }, [
                            _vm._v(
                              _vm._s(_vm.idKidApply.length) +
                                " học sinh đã chọn"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "data-scroll-container" },
                        _vm._l(_vm.kidsDataFilter, function (item) {
                          return _c(
                            "div",
                            { key: item.idClass },
                            [
                              _c(
                                "el-divider",
                                { attrs: { "content-position": "left" } },
                                [
                                  _c("div", [
                                    _c("i", { staticClass: "el-icon-star-on" }),
                                    _c("span", { staticClass: "title_group" }, [
                                      _vm._v(_vm._s(item.className)),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.idKidApply,
                                    callback: function ($$v) {
                                      _vm.idKidApply = $$v
                                    },
                                    expression: "idKidApply",
                                  },
                                },
                                _vm._l(item.students, function (kid) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: kid.idKid,
                                      staticClass: "student-checkbox",
                                      attrs: {
                                        title:
                                          kid.kidsName + " - " + kid.className,
                                        label: kid.idKid,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "album-picker-student-name",
                                        },
                                        [_vm._v(_vm._s(kid.kidsName))]
                                      ),
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "album-picker-student-meta",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.parseKidStatusVietnamese(
                                                kid.statusKids
                                              )
                                            ) +
                                              " · " +
                                              _vm._s(kid.className)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _c("div", { staticClass: "no_data" }, [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _c("span", [_vm._v("Không có dữ liệu")]),
                    ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }